import { useState } from 'react';
import { Eye, EyeOff, Copy, Check } from 'lucide-react';
import { showToast } from '../lib/toast';

export default function TokenDisplay({
    token,
    label,
    color = 'cyan',
    onRegenerate
}) {
    const [isVisible, setIsVisible] = useState(false);
    const [copied, setCopied] = useState(false);

    const copyToClipboard = () => {
        navigator.clipboard.writeText(token);
        setCopied(true);
        showToast.success('Token copied to clipboard');
        setTimeout(() => setCopied(false), 2000);
    };

    const colorClasses = {
        cyan: 'text-cyan-600 dark:text-cyan-400',
        emerald: 'text-emerald-600 dark:text-emerald-400',
        purple: 'text-purple-600 dark:text-purple-400'
    };

    return (
        <div className="bg-surface-200 dark:bg-surface-700/50 rounded p-3">
            <div className="flex items-center justify-between mb-2">
                <span className={`text-xs uppercase tracking-wide font-medium ${colorClasses[color]}`}>
                    {label}
                </span>
                <div className="flex gap-2">
                    <button
                        onClick={() => setIsVisible(!isVisible)}
                        className="text-xs text-slate-500 dark:text-slate-400 hover:text-slate-900 dark:hover:text-white transition-colors"
                        title={isVisible ? 'Hide token' : 'Show token'}
                    >
                        {isVisible ? <EyeOff className="w-4 h-4" /> : <Eye className="w-4 h-4" />}
                    </button>
                    <button
                        onClick={copyToClipboard}
                        className="text-xs text-slate-500 dark:text-slate-400 hover:text-slate-900 dark:hover:text-white transition-colors"
                        title="Copy token"
                    >
                        {copied ? <Check className="w-4 h-4" /> : <Copy className="w-4 h-4" />}
                    </button>
                    {onRegenerate && (
                        <>
                            <span className="text-slate-400 dark:text-slate-600">|</span>
                            <button
                                onClick={onRegenerate}
                                className="text-xs text-amber-600 dark:text-amber-400 hover:text-amber-700 dark:hover:text-amber-300 transition-colors"
                            >
                                Regen
                            </button>
                        </>
                    )}
                </div>
            </div>
            <p className={`font-mono text-sm font-bold ${colorClasses[color]}`}>
                {isVisible ? token : '•'.repeat(Math.min(token.length, 20))}
            </p>
        </div>
    );
}
